
import { z } from "zod";

export const campaignFormSchema = z.object({
  name: z.string().min(1, "Nome é obrigatório"),
  type: z.string().min(1, "Tipo é obrigatório"),
  product: z.enum(['cashback', 'referral'], {
    required_error: "Produto é obrigatório",
  }),
  value: z.number().min(0, "Valor deve ser maior ou igual a zero").optional(),
  start_date: z.date({
    required_error: "Data de início é obrigatória",
  }),
  end_date: z.date({
    required_error: "Data de fim é obrigatória",
  }),
  description: z.string().optional(),
  cashback_template_id: z.string().optional(),
  max_coupons_per_customer: z.number().min(1, "Deve ser pelo menos 1").optional(),
  delay_days: z.number().min(0, "Delay deve ser maior ou igual a zero").optional(),
  // Novos campos para customização de cashback
  use_custom_cashback: z.boolean().optional(),
  custom_cashback_percentage: z.number().min(0).max(100).optional(),
  custom_cashback_multiplier: z.number().min(1).max(10).optional(),
  custom_cashback_expiration_days: z.number().min(1).max(365).optional(),
  // Campos de SMS
  sms_message: z.string().max(160, "Mensagem SMS não pode exceder 160 caracteres").optional(),
  sms_template_id: z.string().optional(),
}).refine((data) => {
  // Para campanhas de primeira compra, valor é obrigatório (porcentagem de desconto)
  if (data.type === 'first_purchase') {
    return data.value !== undefined && data.value !== null && data.value > 0 && data.value <= 100;
  }
  // Para campanhas de referral que precisam de valor
  if (data.product === 'referral' && ['bonus_referral', 'more_discount', 'double_bonus'].includes(data.type)) {
    return data.value !== undefined && data.value !== null && data.value > 0;
  }
  // Para campanhas de cashback que precisam de valor
  if (data.product === 'cashback' && ['accumulated_spending'].includes(data.type)) {
    return data.value !== undefined && data.value !== null && data.value > 0;
  }
  // Para outros tipos onde valor é opcional
  return true;
}, {
  message: "Valor é obrigatório para este tipo de campanha",
  path: ["value"],
}).refine((data) => data.end_date > data.start_date, {
  message: "Data de fim deve ser posterior à data de início",
  path: ["end_date"],
}).refine((data) => {
  // Validar campos de customização de cashback quando use_custom_cashback estiver ativo
  if (data.use_custom_cashback && data.product === 'cashback') {
    return data.custom_cashback_percentage !== undefined && 
           data.custom_cashback_multiplier !== undefined && 
           data.custom_cashback_expiration_days !== undefined;
  }
  return true;
}, {
  message: "Todos os campos de customização de cashback são obrigatórios quando a personalização está ativa",
  path: ["custom_cashback_percentage"],
});

export type CampaignFormData = z.infer<typeof campaignFormSchema>;
